module.exports = __webpack_public_path__ + "img/docx.b7ed7f1f.svg";